import React from 'react';
import './toggle.css';
import { Paragraph } from '../paragraph';

const Toggle = props => {
    const { text, value, onChange } = props;

    return (
        <label htmlFor="toggle" title="toggle">
            <Paragraph
                colorScheme="dark"
                withSpacing={false}
                textAlign="center"
            >
                {text}
            </Paragraph>
            <div className="toggle">
                <input
                    type="checkbox"
                    name="toggle"
                    id="toggle"
                    className="toggle__checkbox"
                    onChange={onChange}
                    checked={value}
                />
                <span className="toggle__slider toggle__slider-round" />
            </div>
        </label>
    );
};

export { Toggle };
